
import { Leave } from '@/types';

// Mock Leave Requests
export const leaves: Leave[] = [
  {
    id: 'leave-1',
    employeeId: 'emp-1',
    type: 'annual',
    startDate: '2023-04-10',
    endDate: '2023-04-15',
    reason: 'Family vacation',
    status: 'approved',
    approvalDate: '2023-03-20'
  },
  {
    id: 'leave-2',
    employeeId: 'emp-2',
    type: 'sick',
    startDate: '2023-04-01',
    endDate: '2023-04-03',
    reason: 'Medical checkup',
    status: 'pending'
  },
  {
    id: 'leave-3',
    employeeId: 'emp-3',
    type: 'maternity',
    startDate: '2023-05-01',
    endDate: '2023-08-01',
    reason: 'Maternity leave',
    status: 'approved',
    approvalDate: '2023-03-15'
  }
];
